<template>
  <div class="control-wrapper">
    <div
      v-if="formatedLayout.rich && richData"
      @click.stop="clickControl('rich_icon')"
    >
      <div
        class="control-icon rich"
        :style="{ backgroundImage: `url(${richData.url})` }"
        @click.stop="clickControl('rich_icon')"
      />
      <div class="number">
        <span v-if="richData.count">{{ formatNum(richData.count) }}</span>
        <span v-else>{{ richData.text }}</span>
      </div>
    </div>
    <div
      v-if="formatedLayout.collection"
      @click.stop="clickControl('collection_icon')"
    >
      <div class="control-icon collection">
        <span
          v-if="collectionKeyword"
          class="keyword"
        >{{
          collectionKeyword
        }}</span>
      </div>
      <div>精选集</div>
    </div>
    <div
      v-if="formatedLayout.like"
      :style="{position: 'relative'}"
      @click.stop="clickControl('like_icon')"
    >
      <JumpMiniApp
        v-if="miniAppPathClickLike"
        :path="miniAppPathClickLike"
        @launch="clickControl('like_icon', true)"
      />
      <div
        class="control-icon"
        :class="[feed.isDing ? 'like-act' : 'like']"
      />
      <div class="number">
        <span>{{ formatNum(feed.dingCount) }}</span>
      </div>
    </div>
    <div
      v-if="formatedLayout.comment"
      :style="{position: 'relative'}"
      @click.stop="clickControl('comment_icon')"
    >
      <JumpMiniApp
        v-if="miniAppPathClickComment"
        :path="miniAppPathClickComment"
        @launch="clickControl('comment_icon', true)"
      />
      <div class="control-icon comment" />
      <div class="number">
        <span>{{ formatNum(feed.totalCommentNum) }}</span>
      </div>
    </div>
    <div
      v-if="formatedLayout.shareText"
      @click.stop="clickControl('share_icon')"
    >
      <div class="control-icon share" />
      <div class="number">
        <span>分享</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ModelMetaFeed } from '@/types/model';
import { IHashMap } from '@/types/data';
import JumpMiniApp from './jump-mini-app.vue';

const enum EEmitEvent {
  onClickControl = 'on-click-control',
}

export default defineComponent({
  components: {
    JumpMiniApp,
  },
  props: {
    layout: {
      type: String,
      default: '',
    },
    feed: {
      type: Object as PropType<ModelMetaFeed>,
      default() {
        return {};
      },
    },
    collectionKeyword: {
      type: String,
      default: '',
    },
    miniAppPathClickLike: {
      type: String,
      default: '',
    },
    miniAppPathClickComment: {
      type: String,
      default: '',
    },
  },
  emits: [EEmitEvent.onClickControl],
  computed: {
    formatedLayout() {
      const ret: IHashMap = {} ;
      this.layout.split(',').forEach((key) => {
        ret[key] = true;
      });
      return ret;
    },
    richData() {
      const data = this.feed.richDing
        ? this.feed.richDing.h5RichDingDisplay
        : { url: '', text: '', count: 0 };
      if (!data || !data.text || !data.url) {
        return null;
      }
      return data;
    },
  },
  methods: {
    clickControl(tag: string, clickMiniApp = false) {
      this.$emit(EEmitEvent.onClickControl, tag, clickMiniApp);
    },
    formatNum(num: number) {
      return num >= 10000 ? `${Number(num / 10000).toFixed(1)}万` : String(num);
    },
  },
});
</script>

<style lang="scss" scoped>
.control-wrapper {
  @include responsiveStyleSingle(width, 9.6, 'vw');
  @include responsiveStyleSingle(font-size, 3.2, 'vw');
  text-align: center;
  white-space: nowrap;
  color: #fff;
  & > div {
    @include responsiveStyleSingle(margin-bottom, 3.2, 'vw');
    &:last-child {
      @include responsiveStyleSingle(margin-bottom, 2.9333, 'vw');
    }
    .control-icon {
      @include responsiveStyleSingle(height, 9.6, 'vw');
      @include responsiveStyleSingle(margin-bottom, 0.8, 'vw');
      background-size: 100% 100%;
      &.collection {
        position: relative;
        background-image: url('https://sola.gtimg.cn/aoi/sola/20200715160609_M5WndAMLBy.png');
        .keyword {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform-origin: center bottom;
          transform: translate3d(-50%, 0, 0) scale(0.5) !important;
          display: inline-block;
          box-sizing: border-box;
          @include responsiveStyleSingle(min-width, 17.0667, 'vw');
          @include responsiveStyleSingle(max-width, 20.2667, 'vw');
          @include responsiveStyleSingle(padding-left, 1.6,'vw');
          @include responsiveStyleSingle(padding-right, 1.6,'vw');
          @include responsiveStyleSingle(height, 6.4, 'vw');
          @include responsiveStyleSingle(line-height, 6.4, 'vw');
          color: #000;
          @include responsiveStyleSingle(font-size, 4.2667, 'vw');
          background: yellow;
          @include responsiveStyleSingle(border-radius, 1.3333, 'vw');
        }
      }
      &.like {
        background-image: url('https://isee.weishi.qq.com/daguo/img/like.png');
      }
      &.like-act {
        background-image: url('https://isee.weishi.qq.com/interact/like-click.png');
      }
      &.comment {
        background-image: url('https://isee.weishi.qq.com/daguo/img/commet.png');
      }
      &.share {
        background-image: url('https://isee.weishi.qq.com/daguo/img/share.png');
      }
    }
    .number {
      display: flex;
      flex-direction: row-reverse;
      @include responsiveStyleSingle(line-height, 4.2667, 'vw');
      span {
        width: 100%;
        font-weight: bold;
      }
    }
  }
  .collection {
    font-weight: bold;
  }
}
</style>
